"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lib_1 = require("../lib");
var apa = window.apa || {};
var namespace = /** @class */ (function () {
    function namespace() {
    }
    // build the basic namespaces that are not built by spine-components
    namespace.prototype.extend = function (spaces, objectToAdd) {
        var spacesArr = spaces.split('.');
        var space = apa;
        for (var i = 0, tLength = spacesArr.length; i < tLength; i++) {
            var tSpace = spacesArr[i];
            if (!space[tSpace])
                space[tSpace] = {};
            if (i == tLength - 1) {
                (0, lib_1.extend)(objectToAdd, space[tSpace]);
                space[tSpace] = objectToAdd;
            }
            else {
                space = space[tSpace];
            }
        }
    };
    ;
    return namespace;
}());
(0, lib_1.extend)(apa, {
    data: {},
    device: {},
    items: {},
    visual: {},
    language: {}
});
apa.namespace = new namespace();
exports.default = apa;
